module.exports = __webpack_public_path__ + "assets/img/address-null-back.8530f7f5.png";